/* Search dialog: predictive results via Section Rendering, recent searches, keyboard navigation. */
(() => {
  'use strict';
  if (window.__purrSearchBound) return;
  window.__purrSearchBound = true;
  const Purr = window.Purr;
  const host = Purr.byRole('search-dialog');
  if (!host) return;
  const input = host.querySelector('[data-search-input]');
  const form = host.querySelector('[data-search-form]');
  const results = host.querySelector('[data-search-results]');
  const defaults = host.querySelector('[data-search-default]');
  const loading = host.querySelector('[data-search-loading]');
  const clearBtn = host.querySelector('[data-search-clear]');
  const recentWrap = host.querySelector('[data-search-recent-wrap]');
  const recentList = host.querySelector('[data-search-recent]');
  if (!input || !form || !results || !defaults || !loading) return;
  const predictive = host.dataset.predictive !== 'false';
  const recentEnabled = !!(recentWrap && recentList); // section setting show_recent
  const STORAGE = 'purr_recent_searches';
  let controller = null;
  let lastTerm = '';

  /* ----- Recent searches ----- */
  const getRecent = () => { try { return JSON.parse(localStorage.getItem(STORAGE) || '[]'); } catch (e) { return []; } };
  const saveRecent = (term) => {
    if (!recentEnabled) return;
    term = (term || '').trim(); if (!term) return;
    const list = [term, ...getRecent().filter((t) => t.toLowerCase() !== term.toLowerCase())].slice(0, 5);
    try { localStorage.setItem(STORAGE, JSON.stringify(list)); } catch (e) { /* ignore */ }
  };
  const renderRecent = () => {
    if (!recentEnabled) return;
    const list = getRecent();
    recentWrap.hidden = list.length === 0;
    recentList.innerHTML = '';
    list.forEach((term) => {
      const li = document.createElement('li');
      const b = document.createElement('button');
      b.type = 'button'; b.className = 'purr-chip'; b.textContent = term; b.dataset.searchSuggest = term;
      li.appendChild(b); recentList.appendChild(li);
    });
  };
  host.querySelector('[data-search-clear-recent]')?.addEventListener('click', () => { try { localStorage.removeItem(STORAGE); } catch (e) {} renderRecent(); });
  renderRecent();

  /* ----- State helpers ----- */
  const showDefault = () => { results.hidden = true; results.innerHTML = ''; defaults.hidden = false; loading.hidden = true; };
  const showResults = (html) => {
    results.innerHTML = html; results.hidden = false; defaults.hidden = true; loading.hidden = true;
    const total = results.querySelector('[data-predictive-results]')?.dataset.total;
    if (total !== undefined) Purr.announce && Purr.announce(total === '0' ? Purr.strings.searchNoResults : Purr.strings.searchResults.replace('{{ count }}', total));
  };

  /* ----- Fetch predictive results ----- */
  const search = async (term) => {
    term = term.trim();
    if (clearBtn) clearBtn.hidden = term.length === 0;
    if (!predictive || term.length < 2) { lastTerm = ''; showDefault(); return; }
    if (term === lastTerm) return;
    lastTerm = term;
    if (controller) controller.abort();
    controller = new AbortController();
    loading.hidden = false;
    defaults.hidden = true;
    const url = Purr.routes.predictiveSearch + '?q=' + encodeURIComponent(term) + '&resources[type]=product,collection,page,article&resources[limit]=6&resources[limit_scope]=each&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,vendor,tag&section_id=' + encodeURIComponent(host.dataset.sectionId || 'search-dialog');
    try {
      const res = await fetch(url, { signal: controller.signal });
      if (!res.ok) throw new Error('search failed');
      const text = await res.text();
      const doc = new DOMParser().parseFromString(text, 'text/html');
      const frag = doc.querySelector('[data-predictive-results]');
      if (frag && term === input.value.trim()) showResults(frag.outerHTML);
    } catch (err) {
      if (err.name === 'AbortError') return;
      loading.hidden = true;
      showDefault();
    }
  };
  const debounced = Purr.debounce(() => search(input.value), 250);

  input.addEventListener('input', debounced);
  clearBtn?.addEventListener('click', () => { input.value = ''; input.focus(); search(''); });
  host.addEventListener('click', (e) => {
    const s = e.target.closest('[data-search-suggest]');
    if (!s) return;
    if (s.tagName === 'A') e.preventDefault();
    input.value = s.dataset.searchSuggest; input.focus(); search(input.value);
  });
  form.addEventListener('submit', (e) => {
    const term = input.value.trim();
    if (!term) { e.preventDefault(); input.focus(); return; }
    saveRecent(term);
  });
  results.addEventListener('click', (e) => { if (e.target.closest('[data-search-item]')) saveRecent(input.value); });

  /* ----- Keyboard navigation through results ----- */
  host.addEventListener('keydown', (e) => {
    if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
    const items = Array.from(host.querySelectorAll('[data-search-item], [data-search-suggest]')).filter((el) => el.offsetParent !== null);
    if (!items.length) return;
    e.preventDefault();
    const idx = items.indexOf(document.activeElement);
    let next;
    if (e.key === 'ArrowDown') next = idx < 0 ? items[0] : items[Math.min(items.length - 1, idx + 1)];
    else next = idx <= 0 ? input : items[idx - 1];
    next.focus();
  });
  host.addEventListener('keydown', (e) => { if (e.key === 'Escape') { host.close && host.close(); } });

  /* ----- Focus on open, reset on close ----- */
  host.addEventListener('purr:dialog:open', () => { renderRecent(); requestAnimationFrame(() => { input.focus(); input.select(); }); });
  host.addEventListener('purr:dialog:close', () => { if (controller) controller.abort(); });

  // "/" shortcut opens search (not while typing)
  document.addEventListener('keydown', (e) => {
    if (e.key !== '/' || e.ctrlKey || e.metaKey || e.altKey) return;
    const tag = (document.activeElement && document.activeElement.tagName) || '';
    if (/INPUT|TEXTAREA|SELECT/.test(tag) || document.activeElement?.isContentEditable) return;
    e.preventDefault(); host.open && host.open();
  });
})();
